import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import useTranslation from "@hooks/use_translation";
import { cn } from "@/lib/utils";
import IdentityVerificationLogo from "@/components/ui/identity_verification_logo";
import { identityVerificationPartnerConfig } from "@/utils/identity_verification_provider";

type Props = {
  className?: string;
  partner?: string | null;
  tooltip?: string | null;
};

const IdentityVerificationBadge: React.FC<Props> = ({ className = "", partner, tooltip }) => {
  const { t } = useTranslation("identity_verification");
  const partnerConfig = identityVerificationPartnerConfig(partner);
  const tooltipLabel = tooltip ?? t("badge.verified", { provider_name: partnerConfig.name });

  if (!tooltipLabel) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn("inline-flex h-5 w-5 items-center justify-center", className)}
          aria-label={tooltipLabel}
          title={tooltipLabel}
        >
          <IdentityVerificationLogo partner={partner} variant="icon" decorative />
        </span>
      </TooltipTrigger>
      <TooltipContent>{tooltipLabel}</TooltipContent>
    </Tooltip>
  );
};

export default IdentityVerificationBadge;
